import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiTableCell: {
  defaultProps?: ComponentsProps['MuiTableCell'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTableCell'];
  variants?: ComponentsVariants['MuiTableCell'];
} = {
  styleOverrides: {
    root: {
      padding: '8px',
    },
    sizeMedium: {
      padding: '8px',
      fontSize: '14px',
    },
    sizeSmall: {
      padding: '4px 8px',
      fontSize: '12px',
    },
  },
};

export default muiTableCell;
